jQuery(document).ready(function($) {

    isSmallMobile = {
        any: function() {
            return $(window).width() < 767;
        }
    };

    // *************************************************************************************************
	//	Footer, Style 1
	// *************************************************************************************************


    if ($(window).width() <= 767) {
        // Changing widgettitle from span to button for accessibility
        $(".footerSection .linkWrapper__widgets li.widget .widgettitle").replaceWith(function() { 
            return "<button class='widgettitle' role='heading' aria-level='3'>" + this.innerHTML + "</button>"; 
        });

        $('.footerSection .linkWrapper__widgets .widget').on('click', function() {
            $(this).toggleClass('active').siblings().removeClass('active');
            $(this).find(' > div').slideToggle().parent().siblings().find(' > div').slideUp();
        });
    }

    // Place Homepage only Javascript inside of IF statement
     if (document.body.classList.contains('home')) {
    
        
        var videos = $(".video-carousel").owlCarousel({
            autoPlay: 7000,
            navigation: true,
            navigationText: ['<i class="fa fa-arrow-left" aria-hidden="true"></i>','<i class="fa fa-arrow-right" aria-hidden="true"></i>'],
            items: 3,
            itemsDesktop: [1280, 3],
            itemsDesktopSmall: [1200, 3],
            itemsTablet: [1025, 1],
            itemsMobile: [720, 1],
            lazyLoad: true
        });
     
        function autoPlayVideo(vcode){
            "use strict";
            $(".video-theater").html('<iframe width="560" height="315" src="'+vcode+'?autoplay=1" rel="0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen wmode="Opaque"></iframe>');
          }
        jQuery('.video-wrapper.yt-wrap').click(function(){
            var video_id = $(this).attr("data-video");
            autoPlayVideo(video_id);
        });

        
     }

});